import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router';
import Store from '../store/Store.js';
import AxiosInterceptor from './reusable/axiosInterception.js';
import ReactGA from 'react-ga';
import InterceptorPopUpContextProvider from '../contexts/interceptorPopUpContext.js';
import InterceptorPopUpList from './reusable/InterceptorPopup/InterceptorPopUpList.js';
import DefineCoreComponents from './System/ForgeCore/DefineCoreComponents.js';
import Loader from './reusable/Loader/Loader.js';
import RegisterAgGridModules from './System/AgGrid/RegisterAgGridModules.js';
import ZoomContextProvider from '../contexts/zoomContext.js';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import TitleUpdater from './System/Misc/TitleUpdater/TitleUpdater.js';
import AppRoutesWrapper from './AppRoutesWrapper.js';
import ErrorPagesContextProvider from './reusable/ErrorPages/errorPagesContext.js';
import SessionChecker from './System/SessionChecker/SessionChecker.js';
import { UserProvider } from '../contexts/userContext.js';
import { NameConventionsProvider } from '../contexts/nameConventionsContext.js';
import { LoaderContextProvider } from '../contexts/loaderContext.js';

export const App = () => {
  useEffect(() => {
    ReactGA.initialize('UA-145825462-1', {
      debug: document.location.hostname !== 'tools.onlinepbb.net/',
    });
  }, []);

  return (
    <Store>
      <ErrorPagesContextProvider>
        <RegisterAgGridModules />
        <LoaderContextProvider>
          <DefineCoreComponents />
          <ZoomContextProvider>
            <DndProvider backend={HTML5Backend}>
              <BrowserRouter>
                <UserProvider>
                  <NameConventionsProvider>
                    <InterceptorPopUpContextProvider>
                      <AxiosInterceptor />
                      <SessionChecker>
                        <TitleUpdater />
                        <AppRoutesWrapper />
                        <InterceptorPopUpList />
                      </SessionChecker>
                    </InterceptorPopUpContextProvider>
                  </NameConventionsProvider>
                </UserProvider>
              </BrowserRouter>
            </DndProvider>
          </ZoomContextProvider>
          <Loader />
        </LoaderContextProvider>
      </ErrorPagesContextProvider>
    </Store>
  );
};

export default App;
